import { DateTime } from 'luxon';

import { ServerChange } from '../../../domain/models/server-change';

export class ServerChangesState {
    public days: number;
    public newServers: ServerChange[];
    public disappearedServers: ServerChange[];
    public validUntil?: DateTime;

    constructor() {
        this.validUntil = null;
        this.newServers = [];
        this.disappearedServers = [];
    }
}
